import React, { useState } from "react";
import { Row, Col, Form, Card, CardBody } from "reactstrap";
import history from "../../history";
import UploadFile from "../UploadFile";
import InputText from "../InputText";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchQueryParams } from "../../utils/comman";

import get from "lodash/get";

const _ = { get };

const initialState = {
  branchId: "",
  title: "",
  author: "",
  description: "",
  image: {
    preview: null,
    Image: null,
  },
};

export default function testimonialCreate(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);

  const handleNameChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleGoBack = () => {
    let queryParams = props.query;
    const params = fetchQueryParams(queryParams);
    if (queryParams === "") {
      history.push(`/branch/list`);
    } else {
      let id = queryParams.replace("?branchId=", "");
      history.push(`/branch/detail?branchId=${id}`)
      console.log("id", id);
      console.log("params", queryParams);
    }
  };

  const handleImageChange = (e) => {
    e.preventDefault();
    var fileTypes = ["jpg", "jpeg", "png"];
    if (e.target.files[0]) {
      var extension = e.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;

      if (isSuccess) {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          saveImage(reader.result, file);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(
          _.get(
            elements,
            "testimonialCreationElements.imageValidationElement",
            "only '.jpg' , '.jpeg' , '.png' file types are accepted"
          )
        );
      }
    } else {
    }

    e.target.value = "";
  };
  const deleteImage = () => {
    state.image.Image = null;
    state.image.preview = null;
    setState({ ...state });
  };

  const saveImage = (preview, Image) => {
    const file = {
      preview,
      Image,
    };
    state.image = file;
    setState({ ...state });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let queryParams = props.query;
    if (queryParams === "") {
      toast.error(
        _.get(
          elements,
          "testimonialCreationElements.branchIdValidationElement",
          "Branch Id not found"
        )
      );
    } else {
      const params = fetchQueryParams(props.query);

      let formData = new FormData();
      formData.append("branchId", params.branchId);
      formData.append("title", state.title);
      formData.append("author", state.author);
      formData.append("description", state.description);
      formData.append("image", state.image.Image);

      let data = {
        formData,
        branchId: params.branchId,
      };
      props.handleCreateBranchTestimonial(data);
    }
  };

  return (
    <div className="hideSearch">
      { props.creatingTestimonialStatus !== false ? <Loader /> : null }
      <Form onSubmit={ handleSubmit }>
        <Row>
          <Col sm={ 12 }>
            <CartTitle
              title={ _.get(
                elements,
                "testimonialCreationElements.headingElement",
                "Testimonial Application"
              ) }
              customClass={ "hidebtn" }
              innerTextClass={ "hidetext" }
              iconClass={ "hideexcel" }
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <h3 className="title-bar secondary-title f-weight-bold mb-3 pb-2 themeColor">
                  { _.get(
                    elements,
                    "testimonialCreationElements.subHeadingElement",
                    "Testimonial"
                  ) }
                </h3>
              </Col>

              <Col xl={ 3 } lg={ 4 } md={ 6 } sm={ 6 } className="mb-2">
                <InputText
                  labelName={ _.get(
                    elements,
                    "testimonialCreationElements.titleLabel",
                    "Title*"
                  ) }
                  inputType={ "text" }
                  inputName={ "title" }
                  InputClass={ "my-2 inputText" }
                  customValue={ state.title }
                  inputPlaceholder={ _.get(
                    elements,
                    "testimonialCreationElements.titlePlaceholder",
                    "Title"
                  ) }
                  customOnChange={ (e) => handleNameChange(e) }
                  customRequired={ true }
                />
              </Col>

              <Col xl={ 3 } lg={ 4 } md={ 6 } sm={ 6 } className="mb-2">
                <InputText
                  labelName={ _.get(
                    elements,
                    "testimonialCreationElements.authorLabel",
                    "Author*"
                  ) }
                  inputType={ "text" }
                  inputName={ "author" }
                  InputClass={ "my-2 inputText" }
                  customValue={ state.author }
                  inputPlaceholder={ _.get(
                    elements,
                    "testimonialCreationElements.authorPlaceholder",
                    "Author"
                  ) }
                  customOnChange={ (e) => handleNameChange(e) }
                  customRequired={ true }
                />
              </Col>
              <Col xl={ 6 } lg={ 6 } md={ 6 } sm={ 6 } className="mb-2">
                <InputText
                  labelName={ _.get(
                    elements,
                    "testimonialCreationElements.descriptionLabel",
                    "Description*"
                  ) }
                  inputType={ "text" }
                  inputName={ "description" }
                  InputClass={ "my-2 inputText" }
                  customValue={ state.description }
                  inputPlaceholder={ _.get(
                    elements,
                    "testimonialCreationElements.descriptionPlaceholder",
                    "Description"
                  ) }
                  customOnChange={ (e) => handleNameChange(e) }
                  customRequired={ true }
                />
              </Col>
              <Col xl={ 12 } lg={ 12 } md={ 12 } sm={ 12 } className="mb-2 pt-4">
                <UploadFile
                  id="image1"
                  image={ state.image }
                  uploadedImage={ state.aboutUsLogo }
                  handleImageChange={ handleImageChange }
                  deleteImage={ deleteImage }
                />
              </Col>
            </Row>
            <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
              <CustomButton
                customType={ "button" }
                name={ _.get(
                  elements,
                  "testimonialCreationElements.backButtonElement",
                  "Back"
                ) }
                customClass={ "btn-outline-dark bg-none ml-2 btnthemeColor" }
                customClick={ () => handleGoBack() }
              />
              <CustomButton
                customType={ "submit" }
                name={ _.get(
                  elements,
                  "testimonialCreationElements.submitButtonElement",
                  "Submit"
                ) }
                customClass={ "btn-outline-dark bg-none ml-2 btnthemeColor" }
              />
            </div>
          </CardBody>
        </Card>
      </Form>
    </div>
  );
}
